import {useShowNavigation} from '@hooks';
import {Navigation} from '../../Navigation';

export const Footer = () => {
  const showNavigation = useShowNavigation();

  if (!showNavigation) {
    return <></>;
  }

  return (
    <div
      className="flex sm:hidden items-center justify-center border-t sticky px-4 bottom-0 z-10 bg-white"
      style={{gridArea: 'footer / fullbleed'}}>
      {showNavigation && <Navigation footer />}
    </div>
  );
};
